// extracted by mini-css-extract-plugin
module.exports = {"item":"sliderTab_item__3R4_I button_button__2n_ir","active":"sliderTab_active__1dVX8"};